/* RESPONSIBLE TEAM: team-automation-foundations */
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

// Pass-through route for /ask/:chat_id — React Router handles the rendering.
export class AskChatRoute extends Route {
  reactEnabled() {
    return true;
  }
}

export default ReactRoute(AskChatRoute);
